module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAYAAACaq43EAAAAOUlEQVRIx2N8r637n2EAAOOoxaMW08zib51dxwbE4v9AMGrxqMXDy2J1dfWByU5A/H/U4lGLh5XFAP73L6WgKeOYAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/ye.png
// module id = 960
// module chunks = 0